<!-- 最新动态 -->
<template>
  <div class="w-full flex flex-col gap-4 bg-gray py-7">
    <!-- 栏目标题 -->
    <div class="flex w-full justify-between pr-4 text-primary">
      <div class="flex flex-col px-6 items-left recentNewsTitle">
        <div class="text-lg font-bold">{{ info?.label }}</div>
        <div class="flex items-center gap-1">
          <div class="w-5 h-0.5 bg-primary" />
          <span class="text-xs font-semibold">{{ info?.englishName }}</span>
        </div>
      </div>

      <div
        class="flex items-center gap-1"
        @click="handleNavigateToList(info?.id)"
      >
        <img :src="require('@/assets/moreIcons.png')" alt="" />
        <span class="text-xs"> 查看更多</span>
      </div>
    </div>
    <!-- 内容 -->
    <div
      class="flex flex-col bg-gray px-4"
      v-for="item in videoInfoList"
      :key="item?.id"
      @click="() => handleNavigateToDetail(item?.id)"
    >
      <!-- 图片 -->
      <div class="w-full h-52">
        <img
          class="w-full h-full"
          :src="'/mainsys/UserFiles/menupic/' + item?.picUrl"
        />
      </div>
      <!-- 标题及描述 -->
      <div class="flex flex-col p-3 gap-1 bg-white">
        <span
          class="text-primary font-black text-base"
          :style="{
            color: '#13499B',
          }"
        >
          {{ item?.title }}
        </span>
        <span
          class="font-light"
          style="
            color: #333333;
            opacity: 0.6;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
          "
        >
          {{ item?.descripton }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { array_ } from "../utils/index";
import mixins from "../hooks";

export default {
  name: "videoColumn",
  mixins: [mixins],
  props: {
    info: {
      default: () => ({}),
    },
  },
  data() {
    return {
      acticveId: null,
    };
  },
  computed: {
    // 当前视频列表
    videoInfoList() {
      return array_(this.info?.newData.slice(0, 3));
    },
    // 当前视频id结合
    videoIDList() {
      return array_(this.videoInfoList).map(({ id }) => id);
    },
  },
  watch: {
    // 数据加载后,默认选中第一个
    videoIDList(val) {
      if (val.length) {
        this.acticveId = val[0];
      }
    },
  },
  methods: {
    // 切换展示视频id | 如果点击已选中的视频则跳转
    handleChangeVideoId(id) {
      if (this.videoIDList.includes(id)) {
        if (this.acticveId === id) {
          this.handleNavigateToDetail(id);
        } else {
          this.acticveId = id;
        }
      }
    },
  },
};
</script>
<style scoped>
.recentNewsTitle {
  background: url("~@/assets/title.png") no-repeat;
  background-size: 75% 100%;
}
</style>
